import {useSelector} from "react-redux";

import {IRPStore} from "../../../app/rp_reducer";
import {IRegionReportPrice} from "../../../region/types/IRegionReportPrice";
import {PricesViewType} from "../helpers/prices_view_type";
import {PricesRegionLayout} from "../layout/PricesRegionLayout";

export const PricesFlatsView = () => {
    const region = useSelector((state: IRPStore) => state.report.price.region);
    const district = useSelector((state: IRPStore) => state.report.price.district);

    return <PricesRegionLayout type={PricesViewType.FLATS} region={region as IRegionReportPrice} district={district}></PricesRegionLayout>;
};
import {useSelector} from "react-redux";

import {IRPStore} from "../../../app/rp_reducer";
import {IRegionReportPrice} from "../../../region/types/IRegionReportPrice";
import {PricesViewType} from "../helpers/prices_view_type";
import {PricesRegionLayout} from "../layout/PricesRegionLayout";

export const PricesFlatsView = () => {
    const region = useSelector((state: IRPStore) => state.report.price.region);
    const district = useSelector((state: IRPStore) => state.report.price.district);

    return <PricesRegionLayout type={PricesViewType.FLATS} region={region as IRegionReportPrice} district={district}></PricesRegionLayout>;
};
